var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('h1',[_vm._v("LottieTest")]),_c('LottieTest',{attrs:{"src":'lottie/'+_vm.i+'.json',"width":"300","height":"300","loop":""},on:{"click":_vm.cambiar}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }